import React from 'react';
import { Scatter } from '@ant-design/charts';

const data = [
  { year: '2008', DART: 0.05, LTIR: 0.03 },
  { year: '2009', DART: 0.07, LTIR: 0.04 },
  { year: '2010', DART: 0.09, LTIR: 0.05 },
  { year: '2011', DART: 0.11, LTIR: 0.06 },
  { year: '2012', DART: 0.13, LTIR: 0.07 },
  { year: '2013', DART: 0.15, LTIR: 0.08 },
  { year: '2014', DART: 0.17, LTIR: 0.09 },
  { year: '2015', DART: 0.20, LTIR: 0.12 },
  { year: '2016', DART: 0.22, LTIR: 0.14 },
  { year: '2017', DART: 0.25, LTIR: 0.15 },
  { year: '2018', DART: 0.30, LTIR: 0.17 },
  { year: '2019', DART: 0.35, LTIR: 0.20 },
  { year: '2020', DART: 0.40, LTIR: 0.25 },
  { year: '2021', DART: 0.45, LTIR: 0.30 },
  { year: '2022', DART: 0.50, LTIR: 0.35 },
  // Add other data points following the above structure
];

const config = {
  data,
  theme: "classicDark",
  height: 300,
  xField: 'DART',
  yField: 'LTIR',
  colorField: 'year',  // Defines the color coding by year
  pointStyle: { radius: 4 },
  xAxis: {
    title: {
      text: 'Days away, restricted or transferred (DART) - employees',
      style: { fontSize: 14 },
    },
    min: 0,
    max: 0.6,
  },
  yAxis: {
    title: {
      text: 'Lost Time Incident Rate (LTIR) - employees',
      style: { fontSize: 14 },
    },
    min: 0,
    max: 0.6,
  },
  legend: {
    position: 'top-left',
    title: { text: 'Year', style: { fontSize: 14 } },
  },
  tooltip: {
    fields: ['year', 'DART', 'LTIR'],
    formatter: (datum) => ({
      name: datum.year,
      value: `DART: ${datum.DART}, LTIR: ${datum.LTIR}`,
    }),
  },
};

const DaysAwayLostTimeChart = () => <Scatter {...config} />;

export default DaysAwayLostTimeChart;
